<template>
  <div>
    <rd-popup v-if="popupVisible" :visibility="popupVisible" :title="getTitle">
      <dx-validation-group
        :ref="`validationGroup`"
        @initialized="validationGroupInitialized"
      >
        <rd-popup-content>
          <div class="row">
            <rd-column :size="$columns.TwelveOnLg" v-if="showParentName">
              <rd-form-group :label="$t('form.label.parentName')">
                <dx-text-box v-model="parentName" :read-only="true">
                </dx-text-box>
              </rd-form-group>
            </rd-column>
            <rd-column :size="$columns.TwelveOnLg">
              <rd-form-group :label="$t('form.label.name')">
                <dx-text-box v-model="name">
                  <dx-validator>
                    <dx-required-rule
                      :message="$t('fieldRules.reuiredShort')"
                    />
                    <dx-string-length-rule
                      :min="3"
                      :message="$t('fieldRules.stringLengthMin', {min:3})"
                    />
                  </dx-validator>
                </dx-text-box>
              </rd-form-group>
            </rd-column>
            <rd-column :size="$columns.TwelveOnLg">
              <rd-form-group :label="$t('form.label.description')">
                <dx-text-box v-model="description">
                  <dx-validator> </dx-validator>
                </dx-text-box>
              </rd-form-group>
            </rd-column>
            <rd-column :size="$columns.TwelveOnLg">
              <rd-form-group :label="$t('form.label.permissions')">
                <dx-drop-down-box
                  v-model="permissions"
                  :show-clear-button="true"
                  :data-source="getPermissions"
                  value-expr="Value"
                  display-expr="Text"
                  :placeholder="$t('form.placeholder')"
                  @value-changed="syncTreeViewSelection($event)"
                >
                  <template #content="{ data }">
                    <DxTreeView
                      ref="permissionTreeView"
                      :data-source="getPermissions"
                      :select-by-click="true"
                      :select-nodes-recursive="false"
                      data-structure="plain"
                      key-expr="Value"
                      parent-id-expr="ParentId"
                      selection-mode="multiple"
                      show-check-boxes-mode="normal"
                      display-expr="Text"
                      @content-ready="syncTreeViewSelection($event)"
                      @item-selection-changed="
                        treeView_itemSelectionChanged($event)
                      "
                    />
                  </template>
                </dx-drop-down-box>
              </rd-form-group>
            </rd-column>
          </div>
        </rd-popup-content>
        <rd-popup-actions>
          <dx-button
            :use-submit-behavior="false"
            styling-mode="text"
            type="normal"
            :text="$t('buttons.cancel')"
            @click="closePopup"
          >
          </dx-button>
          <dx-button
            :use-submit-behavior="false"
            type="default"
            class="ml-1"
            :text="$t('buttons.save')"
            @click="onSave"
          >
          </dx-button>
        </rd-popup-actions>
      </dx-validation-group>
    </rd-popup>
  </div>
</template>

<script>
// @ is an alias to /src
import DxTextBox from 'devextreme-vue/text-box';
import DxButton from 'devextreme-vue/button';
import DxDropDownBox from 'devextreme-vue/drop-down-box';
import DxTreeView from 'devextreme-vue/tree-view';
import { DxRequiredRule, DxStringLengthRule, DxValidator } from "devextreme-vue/validator";
import DxValidationGroup from "devextreme-vue/validation-group";

import { mapGetters, mapActions, mapMutations } from "vuex";
import { mapFields } from "vuex-map-fields";
import commonMessages from "../../locales";
import localMessages from "../locales";
const name = "administrationStores/menuStores/menuTreeStores/folderStore";

export default {
  name: "menuTreeFolder",
  data() {
    return {
      permissionInternal: [],
      popupVisible: false,
    };
  },
  computed: {
    ...mapGetters(name, ["getForm", "getFormState", "getPermissions"]),
    ...mapFields(name, {
      name: "form.name",
      description: "form.description",
      parentName: "form.parentName",
      parentId: "form.parentId",
      permissions: "form.permissions",
    }),   
    showParentName: function() {
      return this.parentId !== null;
    },
    isAddState: function() {
      return this.getFormState === 0;
    },
    isEditState: function() {
      return this.getFormState === 1;
    },
    getTitle: function() {
      if (this.isAddState) {
        return this.$t("form.folder.add.title");
      }
      return this.$t("form.folder.edit.title");
    },
  },
  methods: {
    ...mapActions(name, [
      "getFolderDetails",
      "getTokenWithPermissions",
      "confirmForm",
    ]),
    ...mapMutations(name, ["resetForm", "setFormState"]),
    syncTreeViewSelection(e) {
      let treeView =
        (e.component.selectItem && e.component) ||
        (this.$refs.permissionTreeView &&
          this.$refs.permissionTreeView.instance);

      if (treeView) {
        if (e.value === null) {
          treeView.unselectAll();
        } else {
          let values = e.value || this.permissions;
          values &&
            values.forEach(function(value) {
              treeView.selectItem(value);
            });
        }
      }
    },
    treeView_itemSelectionChanged(e) {   
      this.permissions = e.component.getSelectedNodesKeys();
    },
    closePopup: function() {
      this.popupVisible = false;
      this.resetForm();
    },

    onSave: function(e) {
      let validateResult = this.$refs["validationGroup"].instance.validate();
      if (validateResult.isValid) {
        this.confirmForm().then((id) => {
          this.popupVisible = false;
          var result = {
            id: id,
            name: this.name,
            description: this.description,
            formState: this.getFormState
          };
          this.resetForm();
          this.$emit("confirm", result);
        });
      }
    },
      addFolder() {
      this.setFormState(0);
      this.getTokenWithPermissions().then(() => {
        this.popupVisible = true;
      });
    },
      editFolder(id) {
      this.setFormState(1);
      this.getFolderDetails(id).then(() => {
        this.popupVisible = true;
      });
    },
    validationGroupInitialized(e) {
      let localthis = this;
      setTimeout(function() {
        localthis.$refs["validationGroup"].instance.validate();
      }, 0);
    },
  },
  mounted() {
    // this.setDetails();
  },
  components: {
    DxButton,
    DxValidationGroup,
    DxValidator,
    DxRequiredRule,
    DxStringLengthRule,
    DxTreeView,
    DxDropDownBox,
    DxTextBox
  },
  i18n: {
    messages: localMessages.messages,
    sharedMessages: commonMessages.messages,
  },
};
</script>
